<template>
    <loaderApp v-if="loader" /> 
    <v-container v-else>
        <main>
            <div class="wrap-full-width">
                <div class="row-page-title my-plan-container">
                    <h1>Cancel my plan</h1>
                    <a class="btn-back" @click="clouseCansel" v-if="step1">Close</a>
                    <a class="btn-back" @click="backStep" v-if="step2">Back</a>
                </div>
            </div>
            <!-- <div class="banner-top-1 px-mob">
                <p>{{ bonusSettings.advertisement }}</p>
            </div> -->
            <div class="my-plan-container">
                <div v-if="step1">
                    <div class="row-description step-1">
                        <h4>{{ bonusSettings.title_1 }}</h4>
                        <div v-html="bonusSettings.description_1"></div>                
                    </div>
                    <div class="row-offers" >
                        <div class="wrap-plan flex-column px-md-3 mb-6 d-flex justify-center px-mob">        
                            <div class="d-grid flex-row offrs-grid my-6">
                                <div class="plan-item" v-for="(offer, i) in offers" :key="i" @click="setClassActive(i, 'offers')" :class="[offer.isActive ? 'active' : '']">
                                    <div>
                                        <h2 class="text-left mb-1 mb-md-3"><a :href="offer.link">{{ offer.title }}</a></h2>
                                        <p>{{ offer.excerpt }}</p>
                                        <ul class="d-flex mt-2 mt-md-3">
                                            <li class="pr-2 mr-2"><strong>{{ offer.kcals }}</strong> Cals</li>
                                            <li><strong>{{ offer.protiens }} gr</strong> Protein</li>
                                        </ul>
                                    </div>
                                </div>  
                            </div>
                        </div>
                        <div class="d-flex justify-center my-6 px-mob">
                            <button class="btn-main-app"
                                    :disabled="btnDisabled" 
                                    :data-id="dataID"
                                    data-count="1" 
                                    id="btn-add-bonus"
                                >{{  !btn.check ? btn.title_1 : btn.title_2 }}
                            </button>            
                        </div>
                        <div class="px-mob">
                            <div class="row-btn-cancel mt-6">
                                <button class="btn-cancel" 
                                    @click="nextItem"
                                    >No thanks, cancel my plan
                                </button>
                            </div> 
                        </div> 
                    </div>
                </div>
                <div v-if="step2">
                    <div class="row-description step-2">
                        <h4>{{ bonusSettings.title_2 }}</h4>
                        <div v-html="bonusSettings.description_2"></div>        
                    </div>
                    <div class="row-reasons">
                        <div class="wrap-plan d-flex flex-column justify-center flex-wrap">
                            <div class="plan-item ma-1 ma-md-2" v-for="(reason, i) in reasons" :key="i" @click="setClassActive(i, 'reasons')" :class="{'active': reason.isActive ||  ( i == 4 && reason.isActiveHalf) }" >
                                <p>{{ reason.title }}</p>                                                         
                            </div>  
                        </div>
                        <div v-if="viewField" class="your-answer ma-1 ma-md-2 mt-6">
                            <v-textarea 
                                label="Write your answer choice"
                                @keyup="checkMessage"
                                v-model="message"
                            ></v-textarea>
                        </div>  
                        <div class="d-flex justify-center my-6 px-mob">
                            <button class="btn-main-app" 
                                @click="clouseCansel" 
                                >Keep my plan active
                            </button>            
                        </div>
                        <div class="px-mob">
                            <div class="row-btn-cancel mt-6">
                                <button class="btn-cancel" 
                                    @click="canсelOrder( calselOrderID )"
                                    :disabled="!checkDataSend" 
                                    >Confirm cancellation
                                </button>
                            </div> 
                        </div>
                    </div>
                </div>
                <div v-if="step3" class="text-center d-flex flex-column step-3">
                    <h2>
                        Your order has been canceled.
                    </h2>
                    <p>The money will be refunded within 1 week to your account.</p>
                    <div class="d-flex justify-center px-mob">
                        <button class="btn-main-app"
                            @click="clousePage" 
                            >My Plans
                        </button>            
                    </div>
                </div>
            </div>
             <alertApp />
        </main>
    </v-container>
</template>

<script>

import Cookies from 'js-cookie';
import loaderApp from '@/components/common/loaderApp.vue';
import alertApp from '@/components/common/alertApp.vue';

export default {
    name: 'CanselOrderScreen',
    props: ['bonusSettings', 'offers', 'calselOrderID'],
    components: {
        alertApp,
        loaderApp,
    },
    emits: ['update:visible', 'calselOrderID'],
    data() {
        return {
            step1: true,
            step2: false,
            step3: false,
            btn: {
                check: false,
                title_1: 'Add a protein cookie to my next delivery',
                title_2: 'Added to cart'
            },       
            reasons: [
                {
                    title: 'I’ve reached my goal',
                    isActive: false
                },
                {
                    title: 'I’m going on holiday',
                    isActive: false
                },
                {
                    title: 'I’d rather order individual meals',
                    isActive: false
                },
                {
                    title: 'I’d prefer to order when it suits me',
                    isActive: false
                },
                {
                    title: 'Other(tell us more)',
                    isActive: false,
                    isActiveHalf: false
                }
            ],
            btnDisabled: true,
            viewField: false,
            checkDataSend: false,
            message: ''
        }
    },
    methods: {
        clousePage() {
            window.location.href = '/my-plan/';
        },
        checkMessage() {            
            if ( this.message.length >= 5 ) {
                this.checkDataSend = true;            
            } else {
                this.checkDataSend = false;
            }
        },
        canсelOrder( order ) {
            this.step2 = false;
            this.step3 = true;
            let data = { ID: order }
            let res = this.reasons.filter(reason => ( reason.isActive == true ));
            if ( res.length > 0 ) {
                data.message = res[0].title;
            }

            if ( this.message.length > 0 ) {
                data.message = this.message;
            }
          
            this.$store.dispatch('canсelOrder', { data });
        },
        nextItem() {
            this.step1 = false;
            this.step2 = true;
        },
        backStep() {
            this.step2 = false;
            this.step1 = true;
            this.checkDataSend = false;
            this.viewField = false;
            this.message = '';
            this.reasons.forEach( offer => {
                offer.isActive = false;
                offer.isActiveHalf = false;
            });
        },
        clouseCansel() {
            this.message = '';
            this.reasons.forEach(offer => {
                offer.isActive = false;
                offer.isActiveHalf = false;
            });
            this.checkDataSend = false;
            this.viewField = false;
            
            let elem = document.querySelector('.account-breadcrumbs');
            if ( elem ) {
                elem.classList.remove('hide');
                document.querySelector('.block-name').classList.remove('hide');
                document.querySelector('.account-menu').classList.remove('hide');
                document.querySelector('#content').classList.remove('full-width');
            }

            this.$emit('update:visible', false);
        },
        setClassActive( i, data ) {
            if ( data == 'offers') {
                this.offers.forEach( (offer, index) => {
                    if ( index == i ) {
                        offer.isActive = true;
                    } else {
                        offer.isActive = false;
                    }
                });
                Cookies.set('bonus', true, { expires: 9000000000 });
                this.btnDisabled = false;
            }

            if (data == 'reasons') {
                this.reasons.forEach((offer, index) => {
                    if (index == i) {
                        if ( i == 4 ) {
                            offer.isActive = false;
                            offer.isActiveHalf = true;
                            this.viewField = true;
                        } else {
                            offer.isActive = true;
                            offer.isActiveHalf = false;
                            this.viewField = false;
                        }
                        
                    } else {
                        offer.isActive = false;
                        offer.isActiveHalf = false;
                        this.viewField = false;
                    }
                });

                let res = this.reasons.filter( reason => ( reason.isActive == true ) );
                if ( res.length > 0 ) {
                    this.checkDataSend = true;
                } else {
                    this.checkDataSend = false;
                }
            }
        }        
    },
    computed: {
        loader() {
            return this.$store.getters.loader ?? false;
        },
        banners() {
            return this.$store.getters.banners;
        },
        dataID() {
            let bonus = this.offers.filter(offer => (offer.isActive == true));

            if ( bonus.length > 0 ) { 
                return bonus[0].ID;
            } else {
                return '';
            }
        }
    },
    async beforeMount() {
        let elem1 = document.querySelector('.account-breadcrumbs');
        if ( elem1 ) {
            elem1.classList.add('hide');
            document.querySelector('.block-name').classList.add('hide');
            document.querySelector('.account-menu').classList.add('hide');
            document.querySelector('#content').classList.add('full-width');
        }

        window.scrollTo(0, 0);
    },
    watch: {
    }
}
</script >

<style lang="stylus">
.your-answer {
    border-radius: 10px;
    border: 2px solid #685bc7;
}

.wrap-full-width {
    width: 100%;
    display: flex;
    justify-content: center;
}
.step-3 {
    padding: 100px 0;

    h2 {
        color: #2AD2C9;
        padding-bottom: 5px;
    }
}

.btn-cancel {
    &:disabled {
        opacity: .5;
        cursor: no-drop;
    }
}
.offrs-grid {
    gap: 15px;
    grid-template-columns: 1fr 1fr;
    display: grid;

    .plan-item {
        width: 100%;
        max-width: 100%!important;

        h2 {
            margin-bottom: 5px;

            a {
                text-decoration: none;
                color: #1D2433;
                transition-duration: .4s;
                padding-bottom: 5px;
                display: inline-flex;

                &:hover {
                    color: #685BC7;
                }
            }

        }

        p {
            font-size: 14px;
            font-weight: 400;
        }

        &.active,
        &:hover {
            h2,
            h2 a {
                color: #685BC7!important;
                text-decoration: underline;
            }
        }
    }
}
.row-page-title {
    justify-content: center;
    position: relative;

    a {
        position: absolute;
        left: 20px;
        top: calc(50% - 11px);
        color: #685BC7;
        font-weight: 700;
        font-size: 14px;
        transition-duration: .4s;
        cursor: pointer;

        &:after {
            transition-duration: .4s;
            background-image: url('data:image/svg+xml,<svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.75655 3.91919C5.06135 4.59899 4.36615 5.27824 3.67095 5.95804C3.6484 6.02294 6.3709 7.89899 7.109 8.37749C8.08305 9.00889 8.4213 9.88394 7.9901 10.6017C7.6436 11.1786 6.74215 11.1319 5.7802 10.435C4.41675 9.44779 3.05935 8.45119 1.72945 7.41994C0.588202 6.53499 0.500752 5.51529 1.55125 4.53794C3.06595 3.13049 4.6373 1.77969 6.229 0.456942C6.56395 0.178642 7.0804 0.0801915 7.53085 0.00154153C7.67495 -0.0237585 8.0022 0.268292 8.02365 0.442091C8.05665 0.712141 7.97305 1.05974 7.8108 1.27974C7.1431 2.18064 6.42645 3.04579 5.73125 3.92359C5.734 3.92359 5.80495 3.88564 5.80495 3.88564L5.7571 3.91974L5.75655 3.91919Z" fill="%23685BC7"/></svg>');
            width: 10px;
            height: 13px;
            left: -10px;
            top: 6px;
            content: '';
            position: absolute;
        }

        &:hover {
            color: #2AD2C9;

            &:after {
                background-image: url('data:image/svg+xml,<svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.75655 3.91919C5.06135 4.59899 4.36615 5.27824 3.67095 5.95804C3.6484 6.02294 6.3709 7.89899 7.109 8.37749C8.08305 9.00889 8.4213 9.88394 7.9901 10.6017C7.6436 11.1786 6.74215 11.1319 5.7802 10.435C4.41675 9.44779 3.05935 8.45119 1.72945 7.41994C0.588202 6.53499 0.500752 5.51529 1.55125 4.53794C3.06595 3.13049 4.6373 1.77969 6.229 0.456942C6.56395 0.178642 7.0804 0.0801915 7.53085 0.00154153C7.67495 -0.0237585 8.0022 0.268292 8.02365 0.442091C8.05665 0.712141 7.97305 1.05974 7.8108 1.27974C7.1431 2.18064 6.42645 3.04579 5.73125 3.92359C5.734 3.92359 5.80495 3.88564 5.80495 3.88564L5.7571 3.91974L5.75655 3.91919Z" fill="%232AD2C9"/></svg>');
            }
        }
    }
}

.my-plan-container {
    max-width: 550px!important;
}

.row-page-title {
    padding: 1.5rem 15px;
    text-align :center;

    h1 {
        font-size: 16px;
        line-height: 1.3;
        font-weight: 800;
    }
}

.row-description {
    padding: 15px;
    margin-top: 1rem;

    h4 {
        font-size: 20px;
        margin-bottom: 10px;
    }

    p {
        margin-bottom: 10px;

        strong {
            font-size: 16px;
        }
    }
}

.row-reasons {
    .plan-item {
        height: 64px;
        align-items: center;
        display: flex;
        justify-content: center;
        border-radius: 10px;
        border: 2px solid #E1E6EF;
        transition-duration: .4s; 
        color: #1D2433;
        cursor: pointer;
        min-width: 97%;
        max-width: 100%;

        &:hover {
            border: 2px solid #685bc7;
            color: #685bc7;
        }
    }

    p {
        font-weight: 800;
        font-size: 18px;
    }
}
</style>